/*
 * Помощники для картины по коробкам: глубина, порядок, оттенок, раскладка по номерам.
 * Компонентов здесь больше нет. Полоса в строке формата умерла вместе с прогрессом по
 * форматам — коробка лежит на слове, картина одна на колоду, и рисует её панель
 * методики через MethodDistributionBar. Осталось то, чем пользуются оба: подписи
 * шестерёнки, мобильная шторка и сама панель.
 */

/**
 * Сколько боксов рисовать, пока сводка не пришла. Настоящая глубина — из
 * `reviewIntervalDays` сводки: интервалов на один меньше, чем боксов, потому что первый
 * бокс доступен сразу. Бэкенд задаёт глубину конфигурацией (`card-practice.review-intervals`,
 * шестой бокс — правка конфигурации, а не кода), и клиент не должен спорить с ней константой.
 */
export const DEFAULT_BOX_COUNT = 5;

export const boxCountFor = (reviewIntervalDays) => (
    reviewIntervalDays?.length ? reviewIntervalDays.length + 1 : DEFAULT_BOX_COUNT
);

export const boxIndexes = (boxCount) => Array.from({ length: boxCount }, (_, index) => index);

/**
 * Число слов по боксам длиной `boxCount` из `boxSize` сводки (ключи — номера боксов с
 * нуля). Уровень выше последнего бокса складывается в последний: так его читает и
 * сервер (интервал берётся последний), а бывает это, когда глубину методики уменьшили,
 * а прогресс ещё не переотвечен. Иначе цифры не сходились бы с размером колоды.
 */
export const countsByBox = (boxSize, boxCount) => {
    const counts = new Array(boxCount).fill(0);
    Object.entries(boxSize ?? {}).forEach(([level, count]) => {
        const parsed = Number(level);
        if (!Number.isInteger(parsed)) {
            return;
        }
        counts[Math.min(Math.max(parsed, 0), boxCount - 1)] += count || 0;
    });
    return counts;
};

// Оттенки teal темы от светлого к тёмному (#d3ebe8 … #076168 — те же, что у кнопок и
// ссылок, новой палитры нет). Пять опорных точек подобраны руками под пять боксов; при
// другой глубине шкала та же, цвета берутся с неё равномерно.
const SHADE_STOPS = [[211, 235, 232], [163, 213, 207], [100, 183, 174], [47, 148, 140], [7, 97, 104]];

export const boxShade = (index, boxCount) => {
    const position = boxCount > 1 ? (index / (boxCount - 1)) * (SHADE_STOPS.length - 1) : 0;
    const lower = Math.floor(position);
    const upper = Math.min(lower + 1, SHADE_STOPS.length - 1);
    const weight = position - lower;
    const channel = (c) => Math.round(SHADE_STOPS[lower][c] + (SHADE_STOPS[upper][c] - SHADE_STOPS[lower][c]) * weight);
    return `rgb(${channel(0)}, ${channel(1)}, ${channel(2)})`;
};
